/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface BulletinApprenantRecapitulatifSearch
 */
export interface BulletinApprenantRecapitulatifSearch {
    /**
     * 
     * @type {number}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {number}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    idbulletinApprenantType?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    anneeScolaire?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinApprenantRecapitulatifSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the BulletinApprenantRecapitulatifSearch interface.
 */
export function instanceOfBulletinApprenantRecapitulatifSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulletinApprenantRecapitulatifSearchFromJSON(json: any): BulletinApprenantRecapitulatifSearch {
    return BulletinApprenantRecapitulatifSearchFromJSONTyped(json, false);
}

export function BulletinApprenantRecapitulatifSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulletinApprenantRecapitulatifSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idbulletinApprenantType': !exists(json, 'idbulletinApprenantType') ? undefined : json['idbulletinApprenantType'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function BulletinApprenantRecapitulatifSearchToJSON(value?: BulletinApprenantRecapitulatifSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'idbulletinApprenantType': value.idbulletinApprenantType,
        'anneeScolaire': value.anneeScolaire,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

